import React, { useState } from 'react'
import { ModalWrapper, StyledModalHeader, ModalTitle, ModalBody, SpinnerWrapper } from './LoadingModal.styles'
import { Spinner } from 'reactstrap'

export const LoadingModal = () => {
  const [isOpen] = useState(true)

  return (
    <>
      <ModalWrapper isOpen={isOpen} size='md' centered>
        <StyledModalHeader>
          <ModalTitle>
            Processing Payment...
          </ModalTitle>
        </StyledModalHeader>
        <ModalBody>
          We are currently processing your payment... please do not refresh or leave the page.
        </ModalBody>
        <SpinnerWrapper><Spinner size='sm' /></SpinnerWrapper>
      </ModalWrapper>
    </>
  )
}
